import { render, staticRenderFns } from "./BtnToggle.vue?vue&type=template&id=442240b5&"
import script from "./BtnToggle.vue?vue&type=script&lang=js&"
export * from "./BtnToggle.vue?vue&type=script&lang=js&"
import style0 from "./BtnToggle.vue?vue&type=style&index=0&id=442240b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
